<template>
  <div class='oj_match_offline_match'>
    <MatchOff :theParames='paramse' :selectDefunct="'Y'"></MatchOff>
  </div>
</template>

<script>
import MatchOff from './online_match.vue';
export default {
  name:'oj_match_online_test',
  components:{
    MatchOff
  },
  data(){
    return{
      paramse:{
        defunct:'Y'
      }
    };
  }
};
</script>

<style>

</style>